import React, { useState, useEffect } from 'react'
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  matchPath
} from 'react-router-dom'
import { Layout } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getAllNotifications } from '../reducers/notificationsReducer'
import SideNav from '../components/SideNav'
import PublicRoute from '../components/PublicRoute'
import PrivateRoute from '../components/PrivateRoute'

import RequestOTP from '../pages/Login/index'
import VerifyOTP from '../pages/Login/verifyOtp'
import NotFoundPage from '../pages/NotFoundPage'
import Registeration from '../pages/Registeration'
import ForgetPassword from '../pages/ForgetPassword'
import ResetPasswordPage from '../pages/ForgetPassword/ResetPasswordPage'
import Courses from '../views/courses'
import Articles from '../views/articles'
import MyArticle from '../views/articles/myArticles/myArticles'
import MyBookMarks from '../views/articles/myBookMarks/myBookMarks'
import ArticlePage from '../views/ArticlePage'
import Instructors from '../views/instructors'
import Category from '../views/category'
import Profile from '../views/Profile'
import Exams from '../views/exams'
import { AssessmentCreation, Submissions } from '../views/exams'
import Lectures from '../views/lectures'
import Modules from '../views/modules'
import AssessmentTaking from '../views/assessmentTaking'
import DiscussionFeed from '../views/discussions'
import AnnouncementsFeed from '../views/announcements'
import Dashboard from '../views/dashboard'
import CourseCalendar from '../views/courseCalendar'
import GradeBook from '../views/gradeBook'
import NotFoundView from '../views/NotFoundView'
import Grader from '../views/assessmentGrading'

import 'antd/dist/reset.css'
import S from './style'

import AppHeader from '../components/AppHeader'
import CourseParticipants from '../views/courseParticipants'
import Assignments from '../views/assignments'
import CourseSettings from '../views/courseSettings'
import Achievements from '../views/achievements'
import CourseRoute from '../components/CourseRoute'
import Archives from '../views/archives'
import CourseCertificate from '../views/courses/courseCertificate'

import { io } from 'socket.io-client'

const App = () => {
  return (
    <Routes>
      <Route path="/Register" element={<Registeration />} />
      <Route
        path="/ForgetPassword"
        element={
          <PublicRoute>
            <ForgetPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password/:token"
        element={
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        }
      />
      <Route path="/Login" element={<RequestOTP />} />

      <Route
        path="/verifyotp"
        element={
          <PublicRoute>
            <VerifyOTP />
          </PublicRoute>
        }
      />

      <Route
        path="/app/*"
        element={
          <PrivateRoute>
            <AuthenticatedApp />
          </PrivateRoute>
        }
      />

      <Route path="/" element={<Navigate to="/app" replace />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

const AuthenticatedApp = () => {
  const [collapsed, setCollapsed] = useState(false)
  const { Content } = Layout

  const location = useLocation()
  const courseMatch = matchPath('/app/course/:courseId/*', location.pathname)

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed)
  }
  const user = useSelector((state) => state.auth.user)

  const currentLocationIS = (pathToMatch) => {
    const match = matchPath(
      { path: pathToMatch, end: false },
      location.pathname
    )
    return !!match
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllNotifications())
    const socket = io(process.env.REACT_APP_BACKEND_URL)
    console.log('socket', socket)

    socket.on('newNotification', (payload) => {
      console.log('📩 New notification event:', payload)
      dispatch(getAllNotifications())
    })

    return () => socket.disconnect()
  }, [dispatch])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SideNav collapsed={collapsed} onCollapse={onCollapse} />

      <Layout
        style={{
          marginLeft: collapsed ? 80 : 200,
          transition: 'margin-left .2s'
        }}
      >
        <AppHeader
          courseMatch={courseMatch}
          courseNavigation={currentLocationIS('/app/course/:id')}
          name={user?.name}
        />

        <Content
          style={{
            padding: '20px 32px',
            height: '100%',
            position: 'relative',
            marginTop: '60px'
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/app/courses" replace />} />

            <Route path="dashboard" element={<Dashboard />} />
            <Route path="calendar" element={<CourseCalendar />} />

            <Route path="courses" element={<Courses />} />

            <Route path="course/:courseId" element={<CourseRoute />}>
              <Route path="modules" element={<Modules />} />
              <Route
                path="assessment/:assessmentId/submissions"
                element={<Submissions />}
              />
              <Route
                path="assessment/:assessmentId/grade"
                element={<Grader />}
              />
              <Route
                path="exams/create"
                element={<AssessmentCreation assessmentType="Exam" />}
              />
              <Route
                path="assignments/create"
                element={<AssessmentCreation assessmentType="Assignment" />}
              />
              <Route path="exams" element={<Exams />} />
              <Route path="assignments" element={<Assignments />} />
              <Route path="lectures/:lectureId" element={<Lectures />} />
              <Route path="lectures" element={<Lectures />} />
              <Route
                path="exam/:assessmentId"
                element={<AssessmentTaking assessmentType="Exam" />}
              />
              <Route
                path="assignment/:assessmentId"
                element={<AssessmentTaking assessmentType="Assignment" />}
              />
              <Route
                path="discussions"
                element={
                  <DiscussionFeed courseId={courseMatch?.params?.courseId} />
                }
              />
              <Route
                path="gradebook"
                element={<GradeBook courseId={courseMatch?.params?.courseId} />}
              />
              <Route
                path="announcements"
                element={
                  <AnnouncementsFeed courseId={courseMatch?.params?.courseId} />
                }
              />
              <Route
                path="participants"
                element={
                  <CourseParticipants
                    courseId={courseMatch?.params?.courseId}
                  />
                }
              />
              <Route path="settings" element={<CourseSettings />} />
            </Route>

            <Route
              path="instructors"
              element={
                user?.role === 'admin' ? (
                  <Instructors />
                ) : (
                  <Navigate to="/app/dashboard" replace />
                )
              }
            />
            <Route
              path="category"
              element={
                user?.role === 'admin' ? (
                  <Category />
                ) : (
                  <Navigate to="/app/dashboard" replace />
                )
              }
            />
            <Route path="certificate" element={<CourseCertificate />} />
            <Route path="articles/:id" element={<ArticlePage />} />
            <Route path="articles" element={<Articles />} />
            <Route path="myarticle" element={<MyArticle />} />
            <Route path="myBookMarks" element={<MyBookMarks />} />
            <Route path="profile" element={<Profile />} />
            <Route
              path="archives"
              element={
                user?.role !== 'student' ? (
                  <Archives />
                ) : (
                  <Navigate to="/app/dashboard" replace />
                )
              }
            />
            <Route path="acheivements" element={<Achievements />} />

            <Route path="*" element={<NotFoundView />} />
          </Routes>
        </Content>

        <S.Footer>©2025 Spanidea All Rights Reserved</S.Footer>
      </Layout>
    </Layout>
  )
}

export default App
